<template>
  <div class="box-logo flex justify-center">
    <img
      class="inline-block h-12 w-12 m-auto"
      src="@/assets/logo/logo-chplus-landing.png"
    />
  </div>
</template>

<script>
export default {
  name: "BoxLogo"
};
</script>

<style lang="scss" scoped>
.box-logo {
  height: 4.928rem;
  flex: 0 0 4.928rem;
}

@media (min-width: 768px) {
  .box-logo {
    height: 5.632rem;
    flex: 0 0 5.632rem;
  }
}
</style>
